import React from "react";
import { Input } from "antd";

import "./Inputstyle.scss";

function InputCustom(props) {
  const {
    maxLength,
    basicInput,
    placeholder,
    label,
    labelcustom,
    InputCustomStyle,
    fillBg,
    onChange,
    value,
    disabled,
    editText,
    onClickDiv,
  } = props;

  return (
    <div className="inputLayout">
      {basicInput ? (
        <>
          {label ? (
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <label className={`label ${labelcustom}`}>
                {label}{" "}
              </label>
              {editText && (
                <div
                  onClick={onClickDiv}
                  style={{ justifyContent: "flex-end" }}
                  className={`label ${labelcustom}`}
                >
                  {editText}
                </div>
              )}
            </div>
          ) : null}
          <Input
            maxLength={maxLength || 25}
            className={`inputCustum  ${InputCustomStyle} ${fillBg}`}
            {...props}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            disabled={disabled}
            onWheel={() => document.activeElement.blur()}
          />
        </>
      ) : null}
    </div>
  );
}

export default InputCustom;
